import { render, staticRenderFns } from "./DetailPromoMobile.vue?vue&type=template&id=2491351e&"
import script from "./DetailPromoMobile.vue?vue&type=script&lang=js&"
export * from "./DetailPromoMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports